// Room links in message text: a <#id> token, drawn as the room's chip
// (components/MessageParser) or spelled out as #Name where only text fits.

export const ROOM_LINK_TOKEN = /<#(\d+)>/;
export const DELETED_ROOM_TEXT = '#deleted-room';

// The room a link points at: one you're in (joinedRooms, current name), else
// what the server sent with the message (linkedRooms). null for a deleted
// room, undefined when nothing is known about it.
export function findLinkedRoom(roomId, linkedRooms = null, joinedRooms = null) {
	const joined = joinedRooms && joinedRooms.get(roomId);
	if(joined) {
		return joined;
	}
	if(linkedRooms && Object.prototype.hasOwnProperty.call(linkedRooms, roomId)) {
		return linkedRooms[roomId];
	}
	return undefined;
}

// The text with each token spelled out as #Name.
export function plainRoomLinkText(text, linkedRooms = null, joinedRooms = null) {
	return String(text).replace(new RegExp(ROOM_LINK_TOKEN.source, 'g'), (token, id) => {
		const room = findLinkedRoom(Number.parseInt(id, 10), linkedRooms, joinedRooms);
		if(room === null) {
			return DELETED_ROOM_TEXT;
		}
		return room ? `#${room.name}` : `#${id}`;
	});
}
